import styled from "styled-components";

import { contentStyles } from "./contentStyles";

const ContentStyleHTML = styled.div`
    ${contentStyles}
`;

export const MainContent = styled(ContentStyleHTML).attrs(() => ({ className: "aevi-content-main" as string }))``;

export const AuthContent = styled(ContentStyleHTML).attrs(() => ({ className: "aevi-content-auth" as string }))``;
